<template>
    <AdminList v-if="$store.state.auth.loggedIn && ($store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor')" />
    <PartnerList v-else />
</template>

<script>
import AdminList from './admin/List.vue';
import PartnerList from './partner/List.vue';

export default {
  components: {
    AdminList,
    PartnerList,
  },
};
</script>

<style>

</style>
